import React, { useState, useEffect } from "react";
import { getProfitLoss } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import { allPumps } from "../../../api/endpoints/ceo";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { Select } from "antd";
// import "./PasswordPrompt.css";

const { Option } = Select;

// const PasswordPrompt = ({ onSubmit }) => {
//   const [password, setPassword] = useState("");

//   const handleSubmit = () => {
//     onSubmit(password);
//     setPassword("");
//   };

//   return (
//     <div className="password-overlay">
//       <div className="password-modal">
//         <h2>Enter Password</h2>
//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           autoFocus
//           className="password-input"
//         />
//         <button className="ok-button" onClick={handleSubmit}>
//           OK
//         </button>
//       </div>
//     </div>
//   );
// };

const ProfitLoss = () => {
  const { user, access_token } = useSelector(authSelector);

  const [state, setState] = useState({
    pumpIds: [],
    siteId: "",
    name: "",
    startingDate: "",
    endingDate: "",
  });

  const [showPrompt, setShowPrompt] = useState(false);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const ifCeo = async () => {
    const _pumpIds = await allPumps(access_token);
    setState({
      ...state,
      pumpIds: _pumpIds.data,
    });
  };
  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };
  useEffect(() => {
    if (user.ceo) {
      ifCeo();
    }
    getName();
  }, []);

  const clearFields = () => {
    setState({
      pumpIds: state.pumpIds,
    });
  };

  const [loading, setLoading] = useState(false);

  const editHandler = async () => {
    // setShowPrompt(false);
    // if (!password) return;
    if (!state.startingDate || !state.endingDate)
      return message.error("Please type date !");
    let data = {
      startingDate: state.startingDate,
      endingDate: state.endingDate,
      siteId: user.ceo ? state.siteId : user.siteId
    };
    try {
      setLoading(true); // disable button
      const results = await getProfitLoss(data, access_token);
      if (results.success) {
        const payload = results.data.map((curr) => ({
          itemCode: curr.itemCode,
          itemName: curr.itemName,
          quantity: Number(curr.quantity),
          amount: Number(curr.amount),
          debit: Number(curr.debit),
          credit: Number(curr.credit),
          siteId: Number(curr.siteId),
          generalLedgerCode: Number(curr.generalLedgerCode),
          printOrder: Number(curr.printOrder),
          description: curr.description,
          itemDescription: curr.itemDescription,
          saleQuantity: Number(curr.saleQuantity),
          saleAmount: Number(curr.saleAmount),
          gain: Number(curr.gain),
          rate: Number(curr.rate),
        }));
        setItemsQueue(payload);
        generatePDF(payload);
      } else {
        message.error(results.message);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    } finally {
      setLoading(false); // re-enable button
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const generatePDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("p", "mm", "a4");
    const now = new Date();
    const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    // ===== Header =====
    doc.setFontSize(8);
    doc.text(`Printed on: ${printDateTime}`, 200, 22, { align: "right" });
    doc.setFontSize(16);
    doc.text(siteName, 105, 11, { align: "center" });
    doc.setFontSize(12);
    doc.text(siteAddress, 105, 16, { align: "center" });
    doc.setFontSize(9);
    doc.text(
      `P/L From: ${formatDate(state.startingDate)} To: ${formatDate(
        state.endingDate
      )}`,
      105,
      22,
      {
        align: "center",
      }
    );

    // ===== Helpers =====
    const formatNumber = (num) =>
      Number(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const formatValue = (num) => {
      if (num < 0) return `(${formatNumber(Math.abs(num))})`;
      return formatNumber(num);
    };

    const bodyRows = [];

    //    const addSection = (title, rows, buildRow, calcGross) => {
    //   if (!rows.length) return 0;
    //   let sectionGross = 0;

    //   // Filter out rows where gross = 0
    //   const validRows = rows.filter((ele) => calcGross(ele) !== 0);
    //   if (!validRows.length) return 0;

    //   // Section title row
    //   bodyRows.push([
    //     {
    //       content: title,
    //       colSpan: 6,
    //       styles: { halign: "left", fontStyle: "bold" },
    //     },
    //   ]);

    //   validRows.forEach((ele) => {
    //     const gross = calcGross(ele);
    //     sectionGross += gross;
    //     bodyRows.push(buildRow(ele, gross));
    //   });

    //   // Section total row
    //   bodyRows.push([
    //     {
    //       content: `${title} Total :-`,
    //       colSpan: 5,
    //       styles: { halign: "right", fontStyle: "bold" },
    //     },
    //     {
    //       content: formatValue(sectionGross),
    //       styles: { halign: "right", fontStyle: "bold" },
    //     },
    //   ]);

    //   return sectionGross;
    // };

    const addSection = (title, rows, buildRow, calcGross) => {
      const validRows = rows.filter((ele) => {
        const values = [
          Number(ele.saleQuantity) || 0,
          Number(ele.saleAmount) || 0,
          Number(ele.amount) || 0,
          Number(ele.debit) || 0,
          Number(ele.credit) || 0,
          Number(ele.gain) || 0,
          Number(ele.rate) || 0,
        ];

        return values.some((v) => v !== 0);
      });

      if (!validRows.length) return 0;

      let sectionGross = 0;

      bodyRows.push([
        {
          content: title,
          colSpan: 6,
          styles: { halign: "left", fontStyle: "bold" },
        },
      ]);

      validRows.forEach((ele) => {
        const gross = calcGross(ele);
        sectionGross += gross;
        bodyRows.push(buildRow(ele, gross));
      });

      bodyRows.push([
        {
          content: `${title} Total :-`,
          colSpan: 5,
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: formatValue(sectionGross),
          styles: { halign: "right", fontStyle: "bold" },
        },
      ]);

      return sectionGross;
    };

    // ===== Group Data by printOrder =====
    const bulkSale = data.filter((x) => x.printOrder === 15);
    const fuel = data.filter((x) => x.printOrder === 2);
    const tankGL = data.filter((x) => x.printOrder === 4);
    const rateGain = data.filter((x) => x.printOrder === 5);
    const otherIncome = data.filter((x) => x.printOrder === 9);
    const expense = data.filter((x) => x.printOrder === 10);

    // ===== Build Sections =====
    let bulkGross = addSection(
      "Bulk Sale",
      bulkSale,
      (ele, gross) => [
        ele.itemName,
        formatNumber(ele.saleQuantity),
        formatNumber(ele.saleQuantity !== 0 ? gross / ele.saleQuantity : 0),
        formatNumber(ele.saleAmount),
        formatNumber(ele.rate),
        formatValue(gross),
      ],
      (ele) => ele.saleAmount - ele.rate
    );

    let fuelGross = addSection(
      "Fuel",
      fuel,
      (ele, gross) => [
        ele.description,
        formatNumber(ele.saleQuantity),
        formatNumber(ele.saleQuantity !== 0 ? gross / ele.saleQuantity : 0),
        formatNumber(ele.saleAmount),
        formatNumber(ele.amount),
        formatValue(gross),
      ],
      (ele) => ele.saleAmount - ele.amount
    );

    let tankGLGross = addSection(
      "Tank Gain/Loss",
      tankGL,
      (ele, gross) => [
        ele.itemName,
        formatNumber(ele.gain),
        formatNumber(ele.amount !== 0 ? ele.amount / ele.gain : 0),
        formatNumber(ele.amount),
        "",
        formatValue(gross),
      ],
      (ele) => ele.amount - ele.saleAmount
    );

    let rateGainGross = addSection(
      "Rate Gain/Loss",
      rateGain,
      (ele, gross) => [
        ele.itemName,
        formatNumber(ele.gain),
        formatNumber(ele.amount !== 0 ? ele.amount / ele.gain : 0),
        formatNumber(ele.saleAmount),
        formatNumber(ele.amount),
        formatValue(gross),
      ],
      (ele) => ele.amount - ele.saleAmount
    );

    let otherIncomeGross = addSection(
      "Other Income",
      otherIncome,
      (ele, gross) => [
        ele.description,
        "",
        "",
        formatNumber(ele.credit),
        formatNumber(ele.debit),
        formatValue(gross),
      ],
      (ele) => ele.credit - ele.debit
    );

    // ===== Section Total BEFORE Expenses =====
    const sectionTotal =
      bulkGross + fuelGross + tankGLGross + rateGainGross + otherIncomeGross;

    bodyRows.push([
      {
        content: "Section Total :-",
        colSpan: 5,
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: formatValue(sectionTotal),
        styles: { halign: "right", fontStyle: "bold" },
      },
    ]);

    // ===== Expenses Section =====
    let expenseGross = addSection(
      "Expenses",
      expense,
      (ele, gross) => [
        ele.description,
        "",
        "",
        formatNumber(ele.debit),
        formatNumber(ele.credit),
        formatValue(gross),
      ],
      (ele) => ele.debit - ele.credit
    );

    // ===== Net Profit =====
    const netProfit = sectionTotal - expenseGross;

    bodyRows.push([
      {
        content: "Net Profit :-",
        colSpan: 5,
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: formatValue(netProfit),
        styles: { halign: "right", fontStyle: "bold" },
      },
    ]);

    // ===== Render Table =====
    autoTable(doc, {
      head: [
        [
          "Description",
          "Sale Qty",
          "Margin",
          "Sale Amount",
          "Cost Of Sales",
          "Gross",
        ],
      ],
      body: bodyRows,
      startY: 25,
      theme: "grid",
      margin: { left: 5, right: 5 },
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        valign: "middle",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "left", cellWidth: 50 }, // Description
        1: { halign: "right", cellWidth: 25 }, // Sale Qty
        2: { halign: "right", cellWidth: 25 }, // Margin
        3: { halign: "right", cellWidth: 35 }, // Sale Amount
        4: { halign: "right", cellWidth: 35 }, // Cost of Sales
        5: { halign: "right", cellWidth: 30 }, // Gross
      },
      bodyStyles: {
        lineWidth: 0.2,
        lineColor: [0, 0, 0],
      },
    });

    // ===== Open PDF in New Tab =====
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      {/* <>{showPrompt && <PasswordPrompt onSubmit={editHandler} />}</> */}
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full flex flex-col content-center w-full">
          <Header />
          <div className="flex justify-center mt-32">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className=" text-white">PROFIT & LOSS</h1>
              </div>
              <div className="flex flex-col h-40 content-center items-center justify-items-center justify-evenly">
                <div>
                  <label className="text-white" htmlFor="fname">
                    Starting Date:
                  </label>
                  <input
                    type="date"
                    name="startingDate"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    onChange={onChangeText}
                  />
                </div>
                <div>
                  <label className="text-white" htmlFor="fname">
                    Ending Date:
                  </label>
                  <input
                    type="date"
                    name="endingDate"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    onChange={onChangeText}
                  />
                </div>
                {user.ceo === true && (
                  <div className="flex items-center">
                    <Select
                      showSearch
                      className="mt-2 ml-3 h-8 p-1 w-36"
                      placeholder="pumpId"
                      optionFilterProp="children"
                      value={state.siteId || "pumpId"}
                      onChange={(e) => {
                        const lCode = state.pumpIds.find(
                          (el) => el.siteId === e
                        );
                        setState({
                          ...state,
                          siteId: e,
                          name: lCode.name,
                        });
                      }}
                    >
                      {state.pumpIds.map((el) => (
                        <Option value={el.siteId} key={el.siteId}>
                          {el.siteId}
                        </Option>
                      ))}
                    </Select>
                    <Select
                      showSearch
                      className="mt-2 ml-3 h-8 p-1 w-60"
                      placeholder="Pump Name"
                      optionFilterProp="children"
                      value={state.name || "Pump Name"}
                      onChange={(e) => {
                        const lCode = state.pumpIds.find(
                          (el) => el.siteId === e
                        );
                        setState({
                          ...state,
                          siteId: e,
                          name: lCode.name,
                        });
                      }}
                    >
                      {state.pumpIds.map((el) => (
                        <Option value={el.siteId} key={el.siteId}>
                          {`${el.siteId} - ${el.name}`}
                        </Option>
                      ))}
                    </Select>
                  </div>
                )}
                <div>
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    // onClick={() => setShowPrompt(true)}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    onClick={clearFields}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfitLoss;
